// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// 3rd Party Components
import lodash from 'lodash'
import VueLodash from 'vue-lodash'
// import Vuebar from 'vuebar'
import { rtdbPlugin as VueFire } from 'vuefire'
import VueFuse from 'vue-fuse'
import VeeValidate, { Validator } from 'vee-validate'
import VTooltip from 'v-tooltip'
import Notifications from 'vue-notification'
import VModal from 'vue-js-modal'
import Storage from 'vue-web-storage'
import { sync } from 'vuex-router-sync'
import 'normalize.css'

// App Components
import App from './App'
import router from './router'
import { store } from './store'

// Import Configs
import veeValidateConfig from '@/appConfig/veeValidateConfig'
import validationMessages from '@/appConfig/validationMessages'
const vTooltipOptions = {
  defaultPlacement: 'top',
  defaultTrigger: 'hover focus click'
}

// App Init
sync(store, router) // sync routes in vuex store
Validator.localize('en', validationMessages)

Vue.use(VeeValidate, veeValidateConfig)
Vue.use(VTooltip, vTooltipOptions) // tooltips
Vue.use(VueFire) // firebase bindings
// Vue.use(Vuebar) // custom scrollbar
Vue.use(VueFuse) // fuzzy search
Vue.use(VueLodash, lodash) // utility
Vue.use(Notifications)
Vue.use(VModal, { dialog: true })
Vue.use(Storage, {
  prefix: 'unum_',
  driver: 'session'
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js